var file_upload_viewer_default = {
  "fontElementMap": "rEo-x",
  "file_upload_container": "JGMKn",
  "file_upload_error_container": "eUzSc",
  "file_upload_link": "Eve7R",
  "width_three": "A-zyW",
  "file_upload_text_container": "s-Ro2",
  "width_two": "mJpkA",
  "file_upload_state": "yPsE5",
  "mobile_status_icon": "YQAGD",
  "file_upload_name_container": "zk-IQ",
  "file_upload_name": "tUHAt",
  "file_upload_extension": "w-R-E",
  "width_one": "MXwAV",
  "file_upload_type_icon": "_1q-bI",
  "file_loader_icon": "hs-nj",
  "spin": "-ZBZe",
  "file_upload_type": "pAgZP",
  "file_upload_text_error": "MV0Ww",
  "file_upload_icon_frame": "LFimI",
  "file_upload_icon_background": "vye3f"
};
export {
  file_upload_viewer_default as default
};
//# sourceMappingURL=file-upload-viewer-scss.js.map
